// logo.component.ts
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-logo',
  standalone: true,
  template: `
  @if(type === 'icon'){
    <img src="assets/images/logos/logo_icon.png" alt="Dentium"
                    [style.width]="width"
                    [style.height]="height">
  }
  @else{
    <img src="assets/images/logos/logo_horizontal.png" alt="Dentium"
                    [style.width]="width"
                    [style.height]="height">
  }
  `,
  styles: [`
    :host {
      display: inline-block;
    }
  `]
})
export class LogoComponent {
  @Input() type: 'icon' | 'w-full' = 'icon';
  @Input() width: string = '70px';     // Ancho
  @Input() height: string = 'auto';     // Alto
}
